import styled from 'styled-components'
import type { TabsProps } from './types'

export const Container = styled.div<{
  $direction: NonNullable<TabsProps['direction']>
}>`
  .react-tabs {
    display: flex;
    flex-direction: ${({ $direction }) => ($direction === 'vertical' ? 'row' : 'column')};
    justify-content: space-between;
  }
`
